webpackJsonp([75],{

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRule;
/*
 * 根据给定的多个文件路径引入模块
 * @Author: anker.wang
 * @Date: 2018-01-08 11:23:04
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-07-26 12:37:26
 */

/**
 * 快速制作验证规则
 * https://github.com/yiminghe/async-validator
 * @param {*} message
 * @param {*} type
 * @param {*} trigger
 * @param {*} required
 *
 string: Must be of type string. This is the default type.
 number: Must be of type number.
 boolean: Must be of type boolean.
 method: Must be of type function.
 regexp: Must be an instance of RegExp or a string that does not generate an exception when creating a new RegExp.
 integer: Must be of type number and an integer.
 float: Must be of type number and a floating point number.
 array: Must be an array as determined by Array.isArray.
 object: Must be of type object and not Array.isArray.
 enum: Value must exist in the enum.
 date: Value must be valid as determined by Date
 url: Must be of type url.
 hex: Must be of type hex.
 email: Must be of type email.
 */
function makeRule(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';
  var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'blur';
  var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var rule = { message: message, type: type, trigger: trigger, required: required };
  rule.transform = function (value) {
    // 为空字符串时转换为null
    value === '' && (value = null);
    // 数字类型忽略为null的数字转换
    if (value !== null && ['number', 'integer', 'float'].includes(type)) {
      value = Number(value);
    }
    return value;
  };
  return rule;
}

/***/ }),

/***/ 1455:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

/*
 * ElementUI 下拉远程搜索
 * @Author: anker.wang
 * @Date: 2018-02-08 13:26:37
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-02-08 13:27:08
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      selectLoading: false
    };
  },

  methods: {
    selectRemoteMethod: function selectRemoteMethod(query, request, callback, params) {
      var _this = this;

      if (query !== '') {
        this.selectLoading = true;
        setTimeout(function () {
          request(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ keyword: query }, params)).then(function (response) {
            callback(response.data);
          }).finally(function () {
            _this.selectLoading = false;
          });
        }, 200);
      } else {
        this.rawCustomerItems = [];
      }
    }
  }
});

/***/ }),

/***/ 1593:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_wangeditor__ = __webpack_require__(1594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_wangeditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_wangeditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_auth__ = __webpack_require__(77);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wangEditor',
  props: {
    value: {
      type: String
    },
    tag: {
      type: String,
      default: 'div'
    },
    menus: Array,
    /**
     [
     'head',  // 标题
     'bold',  // 粗体
     'italic',  // 斜体
     'underline',  // 下划线
     'strikeThrough',  // 删除线
     'foreColor',  // 文字颜色
     'backColor',  // 背景颜色
     'link',  // 插入链接
     'list',  // 列表
     'justify',  // 对齐方式
     'quote',  // 引用
     'emoticon',  // 表情
     'image',  // 插入图片
     'table',  // 表格
     'video',  // 插入视频
     'code',  // 插入代码
     'undo',  // 撤销
     'redo'  // 重复
     ]
     */
    colors: Array,
    /**
     [
     '#000000',
     '#eeece0',
     '#1c487f',
     '#4d80bf',
     '#c24f4a',
     '#8baa4a',
     '#7b5ba1',
     '#46acc8',
     '#f9963b',
     '#ffffff'
     ]
     */
    config: Object,
    zIndex: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      editor: null
    };
  },

  watch: {
    value: function value() {
      // 双向绑定，父组件同步到子组件
      if (this.value !== this.editor.txt.html()) {
        this.editor.txt.html(this.value);
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    // 实例化编辑器
    // 双向绑定，子组件同步到父组件
    this.editor = new __WEBPACK_IMPORTED_MODULE_1_wangeditor___default.a(this.$el);

    this.editor.customConfig.uploadImgServer = this.uploadFilePath;
    this.editor.customConfig.uploadFileName = this.uploadFileName;
    this.editor.customConfig.uploadImgHeaders = {
      'SJ-Auth-Token': Object(__WEBPACK_IMPORTED_MODULE_2__utils_auth__["c" /* getToken */])()
    };
    this.editor.customConfig.uploadImgParams = this.uploadFileParams;

    this.editor.customConfig.uploadImgHooks = {
      before: function before(xhr, editor, files) {

        // 图片上传之前触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，files 是选择的图片文件

        // 如果返回的结果是 {prevent: true, msg: 'xxxx'} 则表示用户放弃上传
        // return {
        //     prevent: true,
        //     msg: '放弃上传'
        // }
      },
      success: function success(xhr, editor, result) {
        // 图片上传并返回结果，图片插入成功之后触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
      },
      fail: function fail(xhr, editor, result) {
        // 图片上传并返回结果，但图片插入错误时触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
      },
      error: function error(xhr, editor) {
        // 图片上传出错时触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
      },
      timeout: function timeout(xhr, editor) {
        // 图片上传超时时触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
      },

      // 如果服务器端返回的不是 {errno:0, data: [...]} 这种格式，可使用该配置
      // （但是，服务器端返回的必须是一个 JSON 格式字符串！！！否则会报错）
      customInsert: function customInsert(insertImg, result, editor) {
        // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
        // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果

        // 举例：假如上传图片成功后，服务器端返回的是 {url:'....'} 这种格式，即可这样插入图片：
        var url = result.detail.url;
        insertImg(url);
      }
    };

    this.editor.customConfig.onchange = function (html) {
      if (html !== _this.value) {
        _this.$emit('input', html);
      }
    };
    // 获得焦点事件
    this.editor.customConfig.onfocus = function () {
      _this.$emit('focus');
    };
    // 失去焦点事件
    this.editor.customConfig.onblur = function () {
      _this.$emit('blur');
    };
    // 配置数据
    this.editor.customConfig.zIndex = this.zIndex;
    if (this.menus) this.editor.customConfig.menus = this.menus;
    if (this.colors) this.editor.customConfig.colors = this.colors;
    if (this.config) this.editor.customConfig = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.editor.customConfig, this.config);
    // 创建编辑器
    this.editor.create();
    // 赋初始值
    this.editor.txt.html(this.value);
  },
  destroyed: function destroyed() {
    // 销毁编辑器
    this.editor._offAllEvent();
  },
  render: function render(h) {
    return h(this.tag, {
      class: {},
      style: {}
    }, this.$slots.default);
  }
});

/***/ }),

/***/ 1594:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(992))(79);

/***/ }),

/***/ 2144:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return searchRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return taskTplFormRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return taskFormRules; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__ = __webpack_require__(1345);

/**
 * @file 查理宝编辑页面表单验证
 * @author Anker(anker.wang@slicejobs.com)
 * string, number, boolean, method,
 * regexp, integer, float, array,
 * object, enum, date, url, hex, email
 */



var searchRules = {};

var taskTplFormRules = {
  title: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入模板标题')), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('长度在1到64个字符'), { min: 1, max: 64 })],
  detail: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入模板描述')), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('长度在1到256个字符'), { min: 1, max: 256 })]
};

var taskFormRules = {
  title: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入模板标题')), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('长度在1到64个字符'), { min: 1, max: 64 })],
  content: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入任务描述'))],
  hirenum: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入需要人数', 'integer')), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入大于0的整数', 'integer'), { min: 1 })],
  validcheckindistance: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入有效签到距离', 'number')), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入大于0的数值', 'number'), { min: 0 })],
  processingtime: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入完成时限', 'number')), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入大于0的数值', 'number'), { min: 0 })],
  reviewtime: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入审核周期', 'number')), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入大于0的数值', 'number'), { min: 0 })],
  stepTemplateGroups: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请添加分步模板', 'array', 'change'))]
};

/***/ }),

/***/ 2603:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_WangEditorV3Deprecated__ = __webpack_require__(1593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__clb_task_template_rules_js__ = __webpack_require__(2144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_mixins_selectRemote__ = __webpack_require__(1455);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { WangEditor: __WEBPACK_IMPORTED_MODULE_3__components_WangEditorV3Deprecated__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_5__core_mixins_selectRemote__["a" /* default */]],
  directives: {
    keyupRegExp: {
      componentUpdated: function componentUpdated(el, _ref) {
        var value = _ref.value;

        var input = $('input', el)[0];
        var newValue = input.value.replace(value, '');
        if (input.value !== newValue) {
          input.value = newValue;
        }
      }
    }
  },
  data: function data() {
    return {
      taskTplFormRules: __WEBPACK_IMPORTED_MODULE_4__clb_task_template_rules_js__["c" /* taskTplFormRules */],
      taskFormRules: __WEBPACK_IMPORTED_MODULE_4__clb_task_template_rules_js__["b" /* taskFormRules */],
      customerItems: [],
      userItems: [],
      userTagItems: [],
      dialogBatchUserListVisible: false,
      dialogBatchUserTagListVisible: false,
      dialogTextareaValue: '',
      taskTplForm: {
        title: '',
        detail: '',
        customerid: ''
      },
      updateAllow: false,
      formExtend: {
        restrictedType: '',
        userList: [],
        userTagList: []
      },
      form: {
        title: '',
        content: '',
        type: 0,
        hirenum: 1,
        validcheckindistance: 2,
        processingtime: 12,
        reviewtime: 3,
        gpsCheck: 1,
        priority: 0,
        nearby: 1,
        inhouseprior: 0,
        onlynearby: 0,
        superuserprior: 1,
        multitimes: 0,
        rejectuserrepeat: 1,
        rejecttaskrepeat: 1,
        iscsimage: 0,
        iscskeyin: 0,
        ostype: 0,
        prod_type: 0,
        whitelist: '',
        whitelisttags: '',
        blacklist: '',
        blacklisttags: '',
        stepTemplateGroups: []
      },
      stepTemplateGroup: {
        name: '',
        primary: [],
        secondary: []
      },
      addStepTemplateButtonDisabled: false,
      stepTemplateAttrs: {
        loop: false,
        required: false
      },
      stepTemplateToAdded: null, // 待添加的分步模板
      stepTemplateSelected: null, // 已选中活跃的分步模板
      stepTemplateGroupActiveIndex: '0', // 激活的选项卡
      selectLoading: false,
      stepTemplates: []
    };
  },

  computed: Vuex.mapState({
    typeItems: function typeItems(state) {
      return state.clbTaskTemplate.typeOptions;
    }
  }),
  watch: {
    // 选项卡变更活跃选项
    stepTemplateGroupActiveIndex: function stepTemplateGroupActiveIndex() {
      // 选中模板数据清空
      this.stepTemplateSelected = null;
      // 判断该模板是否可以被添加
      this.stepTemplateToAdded && this.stepTemplateToAddedChange(this.stepTemplateToAdded);
    },
    'formExtend.restrictedType': function formExtendRestrictedType(val) {
      this.form.whitelist = '';
      this.form.whitelisttags = '';
      this.form.blacklist = '';
      this.form.blacklisttags = '';
      if (val === 'white') {
        this.form.whitelist = this.formExtend.userList;
        this.form.whitelisttags = this.formExtend.userTagList;
      }
      if (val === 'black') {
        this.form.blacklist = this.formExtend.userList;
        this.form.blacklisttags = this.formExtend.userTagList;
      }
    },
    'formExtend.userList': function formExtendUserList(val) {
      var restrictedType = this.formExtend.restrictedType;
      if (restrictedType === 'white') {
        this.form.whitelist = val.join(',');
      }
      if (restrictedType === 'black') {
        this.form.blacklist = val.join(',');
      }
    },
    'formExtend.userTagList': function formExtendUserTagList(val) {
      var restrictedType = this.formExtend.restrictedType;
      if (restrictedType === 'white') {
        this.form.whitelisttags = val.join(',');
      }
      if (restrictedType === 'black') {
        this.form.blacklisttags = val.join(',');
      }
    }
  },
  created: function created() {
    this.$store.commit('COLLAPSE_MENU');
    if (this.$route.params.id > 0) {
      this.setTaskTemplate(this.$route.params.id);
    }
  },
  mounted: function mounted() {
    /* 在挂载到实例上去之后被调用 */
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Vuex.mapActions(['getCustomerTable', 'getUserTable', 'getUserTagTable']), {
    onSubmit: function onSubmit() {
      var _this = this;

      this.$refs['taskTplForm'].validate(function (valid) {
        if (valid) {
          _this.$refs['taskForm'].validate(function (valid) {
            if (valid) {
              if (_this.$route.params.id > 0) {
                _this.updateClbTaskTemplate(_this.$route.params.id);
              } else {
                _this.createClbTaskTemplate();
              }
            } else {
              _this.$message.error('提交内容填写不正确！');
            }
          });
        } else {
          _this.$message.error('提交内容填写不正确！');
        }
      });
    },
    createClbTaskTemplate: function createClbTaskTemplate() {
      var _this2 = this;

      request.common('createClbTaskTemplate', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.taskTplForm, { json: this.form })).then(function (res) {
        _this2.$confirm(_this2.$route.meta.title + '成功, 是否继续添加？', '提示', { type: 'success' }).then(function () {
          _this2.$refs.form.resetFields();
        }, function () {
          _this2.$router.push({ path: '/clb-task-template/update/' + res.data.id });
        });
      });
    },
    updateClbTaskTemplate: function updateClbTaskTemplate(id) {
      var _this3 = this;

      request.common('updateClbTaskTemplate', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({ id: id }, this.taskTplForm, { json: this.form })).then(function (res) {
        _this3.$confirm(_this3.$route.meta.title + '成功, 是否前往列表页面？', '提示', { type: 'success' }).then(function () {
          _this3.$router.push({ path: '/clb-task-template/table/' });
        });
      });
    },
    setTaskTemplate: function setTaskTemplate(id) {
      var _this4 = this;

      request.page('getClbTaskTemplate', { id: id }).then(function (_ref2) {
        var data = _ref2.data;

        // 客户白名单
        if (data.customerid > 0) {
          request.page('getCustomerDetail', { id: data.customerid }).then(function (_ref3) {
            var data = _ref3.data;

            _this4.customerItems.push(data);
          });
        } else {
          delete data.customerid;
        }
        // 用户黑白名单 需要拆字符为数组
        if (data.json.whitelist && data.json.whitelisttags) {
          _this4.formExtend.restrictedType = 'white';
          _this4.addBatchToUserList(data.json.whitelist);
          _this4.addBatchToUserTagList(data.json.whitelisttags);
        } else if (data.json.blacklist && data.json.blacklisttags) {
          _this4.formExtend.restrictedType = 'black';
          _this4.addBatchToUserList(data.json.blacklist);
          _this4.addBatchToUserTagList(data.json.blacklisttags);
        }
        filter.setLoop(_this4.taskTplForm, data);
        filter.setLoop(_this4.form, _.omit(data.json, ['whitelist', 'whitelisttags', 'blacklist', 'blacklisttags']));
        _this4.updateAllow = true;
      });
    },

    // 添加一个分步模板组
    addStepTemplateGroup: function addStepTemplateGroup(index) {
      this.form.stepTemplateGroups.push(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _.cloneDeep(this.stepTemplateGroup), {
        name: '模板组' + (index + 1)
      }));
      this.stepTemplateGroupActiveIndex = (this.form.stepTemplateGroups.length - 1).toString();
    },

    // 删除一个分步模板组
    removeStepTemplateGroup: function removeStepTemplateGroup(index) {
      this.form.stepTemplateGroups.splice(index, 1);
      this.stepTemplateSelected = null;
    },

    // 添加一个分步模板到模板组
    addStepTemplate: function addStepTemplate(type) {
      this.addStepTemplateButtonDisabled = true;
      this.getActiveStepTemplateGroup()[type].push(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
        id: this.stepTemplateToAdded.id,
        title: this.stepTemplateToAdded.title
      }, this.stepTemplateAttrs));
    },

    // 删除一个分步模板
    removeStepTemplate: function removeStepTemplate(data, index) {
      // 删除了选中的分步模板
      if (this.stepTemplateSelected && this.stepTemplateSelected.id === data[index].id) {
        this.stepTemplateSelected = null;
      }
      data.splice(index, 1);
    },

    // 获得当前选中的活跃模板组
    getActiveStepTemplateGroup: function getActiveStepTemplateGroup() {
      return this.form.stepTemplateGroups[this.stepTemplateGroupActiveIndex];
    },

    // 待添加分步模板变化事件
    stepTemplateToAddedChange: function stepTemplateToAddedChange(value) {
      var stepTemplateGroup = this.getActiveStepTemplateGroup();
      var stepTemplates = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(stepTemplateGroup.primary), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(stepTemplateGroup.secondary));
      var disabled = false;
      // 判断是否重复
      for (var key in stepTemplates) {
        if (stepTemplates[key].id === value.id) {
          disabled = true;
          break;
        }
      }
      // 按钮禁用
      this.addStepTemplateButtonDisabled = disabled;
    },

    // 分步模板远程检索列表
    stepTemplateRemoteMethod: function stepTemplateRemoteMethod(query) {
      var _this5 = this;

      if (query !== '') {
        this.selectLoading = true;
        setTimeout(function () {
          _this5.selectLoading = false;
          request.alert('getStepTemplateTable', { keyword: query, type: 20 }).then(function (_ref4) {
            var data = _ref4.data;

            _this5.stepTemplates = data.data;
          });
        }, 200);
      }
    },
    customerRemoteMethod: function customerRemoteMethod(query) {
      var _this6 = this;

      this.selectRemoteMethod(query, this.getCustomerTable, function (_ref5) {
        var data = _ref5.data;

        _this6.customerItems = data;
      });
    },
    userRemoteMethod: function userRemoteMethod(query) {
      var _this7 = this;

      this.selectRemoteMethod(query, this.getUserTable, function (_ref6) {
        var data = _ref6.data;

        _this7.userItems = data;
      });
    },
    userTagRemoteMethod: function userTagRemoteMethod(query) {
      var _this8 = this;

      this.selectRemoteMethod(query, this.getUserTagTable, function (_ref7) {
        var data = _ref7.data;

        _this8.userTagItems = data;
      });
    },
    arrayValueNotInteger: function arrayValueNotInteger(array) {
      for (var index = 0; index < array.length; index++) {
        var int = array[index];
        if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(Number(int))) {
          return int;
        }
      }
      return false;
    },
    validateIdList: function validateIdList(array) {
      if (array.constructor === String) {
        array = array.split(',');
      }
      array = _.remove(array, function (value) {
        return value !== '';
      });
      var validate = this.arrayValueNotInteger(array);
      if (validate) {
        this.$notify({
          title: 'ID错误',
          message: validate + '\u4E0D\u662F\u4E00\u4E2A\u6B63\u786E\u7684ID',
          type: 'error',
          duration: 0
        });
        return false;
      }
      return array;
    },
    validateDataExist: function validateDataExist(data, ids, idField) {
      var dataIds = data.map(function (value) {
        return value[idField];
      });
      var diffIds = _.difference(ids, dataIds);
      if (diffIds.length) {
        this.$notify({
          title: 'ID不存在, 请查证后重试',
          message: '' + diffIds.join(','),
          type: 'error',
          duration: 0
        });
        return false;
      } else {
        return dataIds;
      }
    },
    addBatchToUserList: function addBatchToUserList(ids) {
      var _this9 = this;

      ids = this.validateIdList(ids);
      if (!ids) {
        return false;
      }
      request.common('getUserTable', { userid: ids }).then(function (_ref8) {
        var data = _ref8.data;

        var dataIds = _this9.validateDataExist(data.data, ids, 'userid');
        if (!dataIds) {
          return false;
        }
        filter.concatArray(_this9.userItems, data.data, 'userid');
        filter.concatArray(_this9.formExtend.userList, ids);
        _this9.dialogBatchUserListVisible = false;
      });
    },
    addBatchToUserTagList: function addBatchToUserTagList(ids) {
      var _this10 = this;

      ids = this.validateIdList(ids);
      if (!ids) {
        return false;
      }
      request.common('getUserTagTable', { tag_id: ids }).then(function (_ref9) {
        var data = _ref9.data;

        var dataIds = _this10.validateDataExist(data.data, ids, 'id');
        if (!dataIds) {
          return false;
        }
        filter.concatArray(_this10.userTagItems, data.data, 'id');
        filter.concatArray(_this10.formExtend.userTagList, ids);
        _this10.dialogBatchUserTagListVisible = false;
      });
    }
  })
});

/***/ }),

/***/ 281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClbTaskTemplateForm_vue__ = __webpack_require__(2603);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f4f22e2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClbTaskTemplateForm_vue__ = __webpack_require__(3704);
function injectStyle (ssrContext) {
  __webpack_require__(3700)
  __webpack_require__(3702)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8f4f22e2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClbTaskTemplateForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f4f22e2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClbTaskTemplateForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 3700:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3701);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("6a84ba45", content, true, {});

/***/ }),

/***/ 3701:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ClbTaskTemplateForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3702:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3703);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("07250baa", content, true, {});

/***/ }),

/***/ 3703:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".step-template-panel[data-v-8f4f22e2]{border:1px solid #d8dce5;border-radius:4px}.step-template-panel .step-template-container[data-v-8f4f22e2]{padding:10px 15px 0;overflow:hidden}.step-template-panel .step-template-container.border-bottom[data-v-8f4f22e2]{border-bottom:1px solid #d8dce5}.step-template-panel .step-template-container .step-template-type[data-v-8f4f22e2]{padding-right:15px;padding-bottom:10px;float:left}.step-template-panel .step-template-container .step-template-radio-container[data-v-8f4f22e2]{margin-left:57px}.step-template-panel .step-template-container .step-template-radio-container .step-template-name[data-v-8f4f22e2]{padding-right:14px}.step-template-panel .step-template-container .step-template-radio-container .step-template-remove[data-v-8f4f22e2]{position:absolute;right:8px;top:8px;color:#b4bccc}.step-template-panel .step-template-container .step-template-radio-container .step-template-remove[data-v-8f4f22e2]:hover{color:#fa5555}.step-template-panel .step-template-container .step-template-radio-container .step-template-radio[data-v-8f4f22e2]{margin:0 10px 10px 0}.step-template-panel .step-template-container .step-template-radio-container .step-template-radio .el-radio__input[data-v-8f4f22e2]{display:none}.step-template-panel .step-template-container .step-template-radio-container .step-template-radio .el-radio__label[data-v-8f4f22e2]{padding-left:0}.step-template-panel .step-template-container .step-template-radio-container .step-template-icon i[data-v-8f4f22e2]{color:#b4bccc;margin-left:2px;font-size:10px}", "", {"version":3,"sources":["/workspace/src/views/clb-task-template/pages/ClbTaskTemplateForm.vue"],"names":[],"mappings":"AACA,sCAAsC,yBAAyB,iBAAiB,CAC/E,AACD,+DAA+D,oBAAsB,eAAe,CACnG,AACD,6EAA6E,+BAA+B,CAC3G,AACD,mFAAmF,mBAAmB,oBAAoB,UAAU,CACnI,AACD,8FAA8F,gBAAgB,CAC7G,AACD,kHAAkH,kBAAkB,CACnI,AACD,oHAAoH,kBAAkB,UAAU,QAAQ,aAAa,CACpK,AACD,0HAA0H,aAAa,CACtI,AACD,mHAAmH,oBAAwB,CAC1I,AACD,oIAAoI,YAAY,CAC/I,AACD,oIAAoI,cAAgB,CACnJ,AACD,oHAAoH,cAAc,gBAAgB,cAAc,CAC/J","file":"ClbTaskTemplateForm.vue","sourcesContent":["\n.step-template-panel[data-v-8f4f22e2]{border:1px solid #d8dce5;border-radius:4px\n}\n.step-template-panel .step-template-container[data-v-8f4f22e2]{padding:10px 15px 0px;overflow:hidden\n}\n.step-template-panel .step-template-container.border-bottom[data-v-8f4f22e2]{border-bottom:1px solid #d8dce5\n}\n.step-template-panel .step-template-container .step-template-type[data-v-8f4f22e2]{padding-right:15px;padding-bottom:10px;float:left\n}\n.step-template-panel .step-template-container .step-template-radio-container[data-v-8f4f22e2]{margin-left:57px\n}\n.step-template-panel .step-template-container .step-template-radio-container .step-template-name[data-v-8f4f22e2]{padding-right:14px\n}\n.step-template-panel .step-template-container .step-template-radio-container .step-template-remove[data-v-8f4f22e2]{position:absolute;right:8px;top:8px;color:#b4bccc\n}\n.step-template-panel .step-template-container .step-template-radio-container .step-template-remove[data-v-8f4f22e2]:hover{color:#fa5555\n}\n.step-template-panel .step-template-container .step-template-radio-container .step-template-radio[data-v-8f4f22e2]{margin:0px 10px 10px 0px\n}\n.step-template-panel .step-template-container .step-template-radio-container .step-template-radio .el-radio__input[data-v-8f4f22e2]{display:none\n}\n.step-template-panel .step-template-container .step-template-radio-container .step-template-radio .el-radio__label[data-v-8f4f22e2]{padding-left:0px\n}\n.step-template-panel .step-template-container .step-template-radio-container .step-template-icon i[data-v-8f4f22e2]{color:#b4bccc;margin-left:2px;font-size:10px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3704:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(this.$route.params.id > 0 ? '修改查理宝任务模板' : '添加查理宝任务模板'),expression:"this.$route.params.id > 0 ? '修改查理宝任务模板' : '添加查理宝任务模板'"}]},[_c('div',{staticStyle:{"padding-bottom":"20px"}},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":{ path: '/clb-task-template/table' }}},[_vm._v("查理宝任务模板")]),_vm._v(" "),(this.$route.params.id > 0)?_c('el-breadcrumb-item',[_vm._v("修改任务模板")]):_c('el-breadcrumb-item',[_vm._v("添加任务模板")])],1)],1),_vm._v(" "),_c('layout-panel',{staticStyle:{"padding-top":"35px"},attrs:{"show-header":false}},[_c('el-form',{ref:"taskTplForm",staticClass:"layout-submit-form",attrs:{"model":_vm.taskTplForm,"rules":_vm.taskTplFormRules,"size":"medium","label-width":"140px"},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onSubmit()}}},[_c('el-form-item',{staticClass:"medium",attrs:{"label":"模板标题","prop":"title"}},[_c('el-input',{attrs:{"placeholder":"请输入模板标题"},model:{value:(_vm.taskTplForm.title),callback:function ($$v) {_vm.$set(_vm.taskTplForm, "title", $$v)},expression:"taskTplForm.title"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"medium",attrs:{"label":"模板描述","prop":"detail"}},[_c('el-input',{attrs:{"placeholder":"请输入模板描述","type":"textarea","autosize":{ minRows: 2 },"resize":"none"},model:{value:(_vm.taskTplForm.detail),callback:function ($$v) {_vm.$set(_vm.taskTplForm, "detail", $$v)},expression:"taskTplForm.detail"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"medium",attrs:{"label":"客户白名单"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","remote":"","clearable":"","placeholder":"请输入客户名称、客户编号","remote-method":_vm.customerRemoteMethod,"loading":_vm.selectLoading},model:{value:(_vm.taskTplForm.customerid),callback:function ($$v) {_vm.$set(_vm.taskTplForm, "customerid", $$v)},expression:"taskTplForm.customerid"}},_vm._l((_vm.customerItems),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name + '/' + item.number,"value":item.id}})}),1)],1)],1),_vm._v(" "),_c('el-form',{ref:"taskForm",staticClass:"layout-submit-form",attrs:{"model":_vm.form,"rules":_vm.taskFormRules,"size":"medium","label-width":"140px"},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onSubmit()}}},[_c('el-form-item',{staticClass:"medium",attrs:{"label":"任务标题","prop":"title"}},[_c('el-input',{attrs:{"placeholder":"请输入任务标题"},model:{value:(_vm.form.title),callback:function ($$v) {_vm.$set(_vm.form, "title", $$v)},expression:"form.title"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"medium",attrs:{"label":"任务描述","prop":"content"}},[_c('wang-editor',{attrs:{"menus":['head','bold','italic','underline','strikeThrough','foreColor','list','justify','quote','table','undo','redo'],"colors":['#f3605b', '#333']},model:{value:(_vm.form.content),callback:function ($$v) {_vm.$set(_vm.form, "content", $$v)},expression:"form.content"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"small",attrs:{"label":"任务类型"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"请选择任务类型"},model:{value:(_vm.form.type),callback:function ($$v) {_vm.$set(_vm.form, "type", $$v)},expression:"form.type"}},_vm._l((_vm.typeItems),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{staticClass:"mini",attrs:{"label":"需要人数","prop":"hirenum"}},[_c('el-input',{model:{value:(_vm.form.hirenum),callback:function ($$v) {_vm.$set(_vm.form, "hirenum", $$v)},expression:"form.hirenum"}},[_c('template',{slot:"append"},[_vm._v("个")])],2)],1),_vm._v(" "),_c('el-form-item',{staticClass:"mini",attrs:{"label":"有效签到距离/Km","prop":"validcheckindistance"}},[_c('el-input',{model:{value:(_vm.form.validcheckindistance),callback:function ($$v) {_vm.$set(_vm.form, "validcheckindistance", $$v)},expression:"form.validcheckindistance"}},[_c('template',{slot:"append"},[_vm._v("公里")])],2)],1),_vm._v(" "),_c('el-form-item',{staticClass:"mini",attrs:{"label":"完成时限","prop":"processingtime"}},[_c('el-input',{model:{value:(_vm.form.processingtime),callback:function ($$v) {_vm.$set(_vm.form, "processingtime", $$v)},expression:"form.processingtime"}},[_c('template',{slot:"append"},[_vm._v("小时")])],2)],1),_vm._v(" "),_c('el-form-item',{staticClass:"mini",attrs:{"label":"审核周期","prop":"reviewtime"}},[_c('el-input',{model:{value:(_vm.form.reviewtime),callback:function ($$v) {_vm.$set(_vm.form, "reviewtime", $$v)},expression:"form.reviewtime"}},[_c('template',{slot:"append"},[_vm._v("天")])],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"任务提交GPS验证","size":"mini"}},[_c('el-radio-group',{model:{value:(_vm.form.gpsCheck),callback:function ($$v) {_vm.$set(_vm.form, "gpsCheck", $$v)},expression:"form.gpsCheck"}},[_c('el-radio-button',{attrs:{"label":1}},[_vm._v("验证")]),_vm._v(" "),_c('el-radio-button',{attrs:{"label":0}},[_vm._v("不验证")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"任务置顶","size":"mini"}},[_c('el-radio-group',{model:{value:(_vm.form.priority),callback:function ($$v) {_vm.$set(_vm.form, "priority", $$v)},expression:"form.priority"}},[_c('el-radio-button',{attrs:{"label":0}},[_vm._v("不置顶")]),_vm._v(" "),_c('el-radio-button',{attrs:{"label":1}},[_vm._v("置顶")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"附近人员抢单","size":"mini"}},[_c('el-radio-group',{model:{value:(_vm.form.nearby),callback:function ($$v) {_vm.$set(_vm.form, "nearby", $$v)},expression:"form.nearby"}},[_c('el-radio-button',{attrs:{"label":1}},[_vm._v("准许")]),_vm._v(" "),_c('el-radio-button',{attrs:{"label":0}},[_vm._v("不准许")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"店内人员优先","size":"mini"}},[_c('el-radio-group',{model:{value:(_vm.form.inhouseprior),callback:function ($$v) {_vm.$set(_vm.form, "inhouseprior", $$v)},expression:"form.inhouseprior"}},[_c('el-radio-button',{attrs:{"label":0}},[_vm._v("不优先")]),_vm._v(" "),_c('el-radio-button',{attrs:{"label":1}},[_vm._v("优先")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"任务显示","size":"mini"}},[_c('el-radio-group',{model:{value:(_vm.form.onlynearby),callback:function ($$v) {_vm.$set(_vm.form, "onlynearby", $$v)},expression:"form.onlynearby"}},[_c('el-radio-button',{attrs:{"label":0}},[_vm._v("不限制")]),_vm._v(" "),_c('el-radio-button',{attrs:{"label":1}},[_vm._v("仅在周边显示")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"金牌人员优先","size":"mini"}},[_c('el-radio-group',{model:{value:(_vm.form.superuserprior),callback:function ($$v) {_vm.$set(_vm.form, "superuserprior", $$v)},expression:"form.superuserprior"}},[_c('el-radio-button',{attrs:{"label":1}},[_vm._v("优先")]),_vm._v(" "),_c('el-radio-button',{attrs:{"label":0}},[_vm._v("不优先")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"多次接单","size":"mini"}},[_c('el-radio-group',{model:{value:(_vm.form.multitimes),callback:function ($$v) {_vm.$set(_vm.form, "multitimes", $$v)},expression:"form.multitimes"}},[_c('el-radio-button',{attrs:{"label":0}},[_vm._v("不准许")]),_vm._v(" "),_c('el-radio-button',{attrs:{"label":1}},[_vm._v("准许")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"审核不通过重复执行","size":"mini"}},[_c('el-radio-group',{model:{value:(_vm.form.rejectuserrepeat),callback:function ($$v) {_vm.$set(_vm.form, "rejectuserrepeat", $$v)},expression:"form.rejectuserrepeat"}},[_c('el-radio-button',{attrs:{"label":1}},[_vm._v("用户准许")]),_vm._v(" "),_c('el-radio-button',{attrs:{"label":0}},[_vm._v("用户不准许")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"","size":"mini"}},[_c('el-radio-group',{model:{value:(_vm.form.rejecttaskrepeat),callback:function ($$v) {_vm.$set(_vm.form, "rejecttaskrepeat", $$v)},expression:"form.rejecttaskrepeat"}},[_c('el-radio-button',{attrs:{"label":1}},[_vm._v("任务准许")]),_vm._v(" "),_c('el-radio-button',{attrs:{"label":0}},[_vm._v("任务不准许")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"众包审核照片","size":"mini"}},[_c('el-radio-group',{attrs:{"disabled":""},model:{value:(_vm.form.iscsimage),callback:function ($$v) {_vm.$set(_vm.form, "iscsimage", $$v)},expression:"form.iscsimage"}},[_c('el-radio-button',{attrs:{"label":1}},[_vm._v("是")]),_vm._v(" "),_c('el-radio-button',{attrs:{"label":0}},[_vm._v("否")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"众包Key-in","size":"mini"}},[_c('el-radio-group',{attrs:{"disabled":""},model:{value:(_vm.form.iscskeyin),callback:function ($$v) {_vm.$set(_vm.form, "iscskeyin", $$v)},expression:"form.iscskeyin"}},[_c('el-radio-button',{attrs:{"label":1}},[_vm._v("是")]),_vm._v(" "),_c('el-radio-button',{attrs:{"label":0}},[_vm._v("否")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"发布平台","size":"mini"}},[_c('el-radio-group',{model:{value:(_vm.form.ostype),callback:function ($$v) {_vm.$set(_vm.form, "ostype", $$v)},expression:"form.ostype"}},[_c('el-radio-button',{attrs:{"label":0}},[_vm._v("不限制")]),_vm._v(" "),_c('el-radio-button',{attrs:{"label":10}},[_vm._v("Android")]),_vm._v(" "),_c('el-radio-button',{attrs:{"label":20}},[_vm._v("iOS")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"适用检查类型","size":"mini"}},[_c('el-radio-group',{model:{value:(_vm.form.prod_type),callback:function ($$v) {_vm.$set(_vm.form, "prod_type", $$v)},expression:"form.prod_type"}},[_c('el-radio-button',{attrs:{"label":0}},[_vm._v("SKU")]),_vm._v(" "),_c('el-radio-button',{attrs:{"label":1}},[_vm._v("品牌")]),_vm._v(" "),_c('el-radio-button',{attrs:{"label":2}},[_vm._v("活动")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"用户限制类型","size":"mini"}},[_c('el-radio-group',{model:{value:(_vm.formExtend.restrictedType),callback:function ($$v) {_vm.$set(_vm.formExtend, "restrictedType", $$v)},expression:"formExtend.restrictedType"}},[_c('el-radio-button',{attrs:{"label":""}},[_vm._v("不限制")]),_vm._v(" "),_c('el-radio-button',{attrs:{"label":"black"}},[_vm._v("黑名单")]),_vm._v(" "),_c('el-radio-button',{attrs:{"label":"white"}},[_vm._v("白名单")])],1)],1),_vm._v(" "),(_vm.formExtend.restrictedType !== '')?_c('div',[_c('el-form-item',{staticClass:"medium",attrs:{"label":"限制用户","size":"mini"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","remote":"","multiple":"","placeholder":"请输入用户ID、名称","remote-method":_vm.userRemoteMethod,"loading":_vm.selectLoading},model:{value:(_vm.formExtend.userList),callback:function ($$v) {_vm.$set(_vm.formExtend, "userList", $$v)},expression:"formExtend.userList"}},_vm._l((_vm.userItems),function(ref){
var userid = ref.userid;
var cellphone = ref.cellphone;
return _c('el-option',{key:userid,attrs:{"label":cellphone + '/' + userid,"value":userid}})}),1),_vm._v(" "),_c('el-button',{attrs:{"type":"text","size":"mini"},on:{"click":function($event){_vm.dialogBatchUserListVisible = true}}},[_vm._v("\n            批量添加用户\n          ")])],1),_vm._v(" "),_c('el-form-item',{staticClass:"medium",attrs:{"label":"限制用户标签","size":"mini"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","remote":"","multiple":"","placeholder":"请输入用户标签ID、名称","remote-method":_vm.userTagRemoteMethod,"loading":_vm.selectLoading},model:{value:(_vm.formExtend.userTagList),callback:function ($$v) {_vm.$set(_vm.formExtend, "userTagList", $$v)},expression:"formExtend.userTagList"}},_vm._l((_vm.userTagItems),function(ref){
var id = ref.id;
var tagname = ref.tagname;
return _c('el-option',{key:id,attrs:{"label":tagname + '/' + id,"value":id}})}),1),_vm._v(" "),_c('el-button',{attrs:{"type":"text","size":"mini"},on:{"click":function($event){_vm.dialogBatchUserTagListVisible = true}}},[_vm._v("\n            批量添加标签\n          ")])],1)],1):_vm._e(),_vm._v(" "),_c('el-form-item',{staticStyle:{"padding-bottom":"5px"},attrs:{"label":"分步模板","size":"mini","prop":"stepTemplateGroups"}},[_c('el-row',{staticStyle:{"margin-bottom":"5px"}},[_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){return _vm.addStepTemplateGroup(_vm.form.stepTemplateGroups.length)}}},[_vm._v("\n            添加模板组\n          ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.stepTemplateGroups.length > 0),expression:"form.stepTemplateGroups.length > 0"}]},[_c('el-select',{attrs:{"filterable":"","remote":"","placeholder":"请输入名称/ID","value-key":"id","remote-method":_vm.stepTemplateRemoteMethod,"loading":_vm.selectLoading},on:{"change":_vm.stepTemplateToAddedChange},model:{value:(_vm.stepTemplateToAdded),callback:function ($$v) {_vm.stepTemplateToAdded=$$v},expression:"stepTemplateToAdded"}},_vm._l((_vm.stepTemplates),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.title,"value":item}},[_c('span',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('span',{staticClass:"info"},[_vm._v("id: "+_vm._s(item.id))])])}),1),_vm._v(" "),_c('el-button',{attrs:{"disabled":!_vm.stepTemplateToAdded || _vm.addStepTemplateButtonDisabled,"size":"mini"},on:{"click":function($event){return _vm.addStepTemplate('primary')}}},[_vm._v("添加到主模板")]),_vm._v(" "),_c('el-button',{attrs:{"disabled":!_vm.stepTemplateToAdded || _vm.addStepTemplateButtonDisabled,"size":"mini"},on:{"click":function($event){return _vm.addStepTemplate('secondary')}}},[_vm._v("添加到从模板")])],1)],1),_vm._v(" "),_c('el-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.stepTemplateGroups.length),expression:"form.stepTemplateGroups.length"}],staticStyle:{"margin-top":"10px","margin-bottom":"5px"}},[_c('el-tabs',{attrs:{"type":"card","closable":""},on:{"tab-remove":_vm.removeStepTemplateGroup},model:{value:(_vm.stepTemplateGroupActiveIndex),callback:function ($$v) {_vm.stepTemplateGroupActiveIndex=$$v},expression:"stepTemplateGroupActiveIndex"}},_vm._l((_vm.form.stepTemplateGroups),function(ref,index){
var name = ref.name;
var primary = ref.primary;
var secondary = ref.secondary;
return _c('el-tab-pane',{key:index,attrs:{"label":name,"name":index.toString()}},[_c('div',{staticClass:"step-template-panel"},[_c('div',{staticClass:"step-template-container border-bottom"},[_c('div',{staticClass:"step-template-type"},[_c('b',[_vm._v("组名称")])]),_vm._v(" "),_c('div',{staticClass:"step-template-radio-container"},[_c('el-input',{staticStyle:{"width":"300px"},attrs:{"placeholder":"请输入模板标题"},model:{value:(_vm.form.stepTemplateGroups[index].name),callback:function ($$v) {_vm.$set(_vm.form.stepTemplateGroups[index], "name", $$v)},expression:"form.stepTemplateGroups[index].name"}})],1)]),_vm._v(" "),_c('div',{staticClass:"step-template-container border-bottom"},[_c('div',{staticClass:"step-template-type"},[_c('b',[_vm._v("主模板")])]),_vm._v(" "),_c('div',{staticClass:"step-template-radio-container"},_vm._l((primary),function(items,index){return _c('el-tooltip',{key:items.id,staticClass:"item",attrs:{"effect":"dark","content":'ID:' + items.id,"placement":"top"}},[_c('el-radio',{staticClass:"step-template-radio",attrs:{"border":"","label":items},model:{value:(_vm.stepTemplateSelected),callback:function ($$v) {_vm.stepTemplateSelected=$$v},expression:"stepTemplateSelected"}},[_c('span',{staticClass:"step-template-name"},[_c('span',[_vm._v(_vm._s(items.title))]),_vm._v(" "),_c('span',{staticClass:"step-template-icon"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(items.required),expression:"items.required"}],staticClass:"el-icon-check"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(items.loop),expression:"items.loop"}],staticClass:"el-icon-refresh"})])]),_vm._v(" "),_c('span',{staticClass:"el-icon-error step-template-remove",on:{"click":function($event){$event.preventDefault();return _vm.removeStepTemplate(primary, index)}}})])],1)}),1)]),_vm._v(" "),_c('div',{staticClass:"step-template-container"},[_c('div',{staticClass:"step-template-type"},[_c('b',[_vm._v("从模板")])]),_vm._v(" "),_c('div',{staticClass:"step-template-radio-container"},_vm._l((secondary),function(items,index){return _c('el-tooltip',{key:items.id,staticClass:"item",attrs:{"effect":"dark","content":'ID:' + items.id,"placement":"top"}},[_c('el-radio',{staticClass:"step-template-radio",attrs:{"border":"","label":items},model:{value:(_vm.stepTemplateSelected),callback:function ($$v) {_vm.stepTemplateSelected=$$v},expression:"stepTemplateSelected"}},[_c('span',{staticClass:"step-template-name"},[_c('span',[_vm._v(_vm._s(items.title))]),_vm._v(" "),_c('span',{staticClass:"step-template-icon"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(items.required),expression:"items.required"}],staticClass:"el-icon-check"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(items.loop),expression:"items.loop"}],staticClass:"el-icon-refresh"})])]),_vm._v(" "),_c('span',{staticClass:"el-icon-error step-template-remove",on:{"click":function($event){$event.preventDefault();return _vm.removeStepTemplate(secondary, index)}}})])],1)}),1)])])])}),1),_vm._v(" "),(_vm.stepTemplateSelected)?_c('div',{staticStyle:{"padding-top":"10px"}},[_c('el-checkbox',{model:{value:(_vm.stepTemplateSelected.required),callback:function ($$v) {_vm.$set(_vm.stepTemplateSelected, "required", $$v)},expression:"stepTemplateSelected.required"}},[_vm._v("必选")]),_vm._v(" "),_c('el-checkbox',{model:{value:(_vm.stepTemplateSelected.loop),callback:function ($$v) {_vm.$set(_vm.stepTemplateSelected, "loop", $$v)},expression:"stepTemplateSelected.loop"}},[_vm._v("循环")])],1):_vm._e()],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"danger","disabled":this.$route.params.id > 0 && !_vm.updateAllow},on:{"click":_vm.onSubmit}},[(this.$route.params.id > 0)?_c('span',[_vm._v("保存修改")]):_c('span',[_vm._v("立即创建")])])],1)],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"批量添加用户","visible":_vm.dialogBatchUserListVisible,"width":"400px"},on:{"update:visible":function($event){_vm.dialogBatchUserListVisible=$event}}},[_c('el-input',{attrs:{"placeholder":"输入用户ID英文逗号分隔，示例：669,670,671,672","type":"textarea","autosize":{ minRows: 5 },"resize":"none"},model:{value:(_vm.dialogTextareaValue),callback:function ($$v) {_vm.dialogTextareaValue=$$v},expression:"dialogTextareaValue"}}),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.dialogBatchUserListVisible = false; _vm.dialogTextareaValue = ''}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","disabled":_vm.dialogTextareaValue === ''},on:{"click":function($event){_vm.addBatchToUserList(_vm.dialogTextareaValue); _vm.dialogTextareaValue = ''}}},[_vm._v("确 定")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"批量添加用户标签","visible":_vm.dialogBatchUserTagListVisible,"width":"400px"},on:{"update:visible":function($event){_vm.dialogBatchUserTagListVisible=$event}}},[_c('el-input',{attrs:{"placeholder":"输入用户标签ID英文逗号分隔，示例：669,670,671,672","type":"textarea","autosize":{ minRows: 5 },"resize":"none"},model:{value:(_vm.dialogTextareaValue),callback:function ($$v) {_vm.dialogTextareaValue=$$v},expression:"dialogTextareaValue"}}),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.dialogBatchUserTagListVisible = false; _vm.dialogTextareaValue = ''}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","disabled":_vm.dialogTextareaValue === ''},on:{"click":function($event){_vm.addBatchToUserTagList(_vm.dialogTextareaValue); _vm.dialogTextareaValue = ''}}},[_vm._v("确 定")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/clb-task-template-form.a0f02bb508e6e12df21b.js